import {MetricType} from 'common/query-builder/query-block/constants';
import {
  ATTRIBUTION_OPTIONS,
  ATTRIBUTION_OPTIONS_REPORT_CONSISTENCY,
  ATTRIBUTION_TYPE_TOOLTIPS,
} from 'common/report/funnels/models/constants';
import {MetricEntry} from 'common/query-builder/query-entry-section/types';
import {SectionItem} from 'common/components/items-menu/types';

import {isBehaviorShowClause} from '../models/utils';
import {ShowClause} from './types';

export function getFunnelAttributionItems(showClauses: ShowClause[]) {
  if (
    showClauses.length === 1 &&
    isBehaviorShowClause(showClauses[0]) &&
    showClauses[0].behavior.type === MetricType.Funnel
  ) {
    const {behaviors} = showClauses[0].behavior;
    const {actionMode, actionStep} = showClauses[0].measurement;
    return getAttributionItems(ATTRIBUTION_OPTIONS, behaviors.length, actionMode === `step` ? actionStep : actionMode);
  }
  return null;
}

export function getFunnelMetricAttributionItems(entry: MetricEntry) {
  const {behaviors} = entry.behavior;
  const {attributionSelection} = entry.measurement;
  return getAttributionItems(ATTRIBUTION_OPTIONS_REPORT_CONSISTENCY, behaviors.length, attributionSelection);
}

function getAttributionItems(
  propertyOptions: SectionItem[],
  numBehaviors: number,
  attributionSelection?: number | string,
) {
  const stepItems = [...Array(numBehaviors)].map((_, index) => ({
    label: `Step ${index + 1}`,
    value: index + 1,
    isSelected: false,
  }));
  const items = propertyOptions.concat(stepItems);

  let selectedIndex = items.map((item) => item.value, 10).indexOf(attributionSelection);
  if (selectedIndex < 0) {
    selectedIndex = 0;
  }
  return items.map((item, index) => ({
    ...item,
    value: item.value,
    index: String(index),
    isSelected: index === selectedIndex,
    tooltip: ATTRIBUTION_TYPE_TOOLTIPS[item.value],
  }));
}
